import { useMemo } from "react";
import { Badge, Divider, Menu, Typography } from "antd";
import {
  DashboardOutlined,
  TeamOutlined,
  CalendarOutlined,
  CommentOutlined,
  IdcardOutlined,
  ApartmentOutlined,
  SolutionOutlined,
  TagOutlined,
  UsergroupAddOutlined,
  DeploymentUnitOutlined,
  FileTextOutlined,
  PictureOutlined,
  TableOutlined,
  SignatureOutlined,
  CheckSquareOutlined,
} from "@ant-design/icons";
import { StyledSideBar, Logo, SidebarContent, MenuSection } from "./styles";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constant/routes";
import { useSelector } from "react-redux";
import LogoImage from "../../../assets/images/logo.png";
import { selectNewMessageCount } from "../../../store/chats/selectors";
import MoreMenu from "./MoreMenu";
import TenantMenu from "./TenantMenu";

const Sidebar = ({ collapsed = true, setCollapsed }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const newMessageCount = useSelector(selectNewMessageCount);

  const communicationItems = useMemo(
    () => [
      {
        key: ROUTES.CHATS,
        icon: <CommentOutlined />,
        label: (
          <span>
            Conversations
            {newMessageCount ? (
              <Badge
                count={
                  <Badge count={newMessageCount} style={{ marginLeft: 8 }} />
                }
                style={{ marginLeft: 8 }}
              />
            ) : (
              <></>
            )}
          </span>
        ),
      },
      {
        key: ROUTES.CUSTOMERS,
        icon: <IdcardOutlined />,
        label: "Customers",
      },
      {
        key: ROUTES.POSTER,
        icon: <PictureOutlined />,
        label: "Poster",
      },
      {
        key: ROUTES.OPENSIGN,
        icon: <SignatureOutlined />,
        label: "Open Sign",
      },
      {
        key: ROUTES.TASKS,
        icon: <CheckSquareOutlined />,
        label: "Task Management",
      },
      {
        key: ROUTES.SPREADSHEET,
        icon: <TableOutlined />,
        label: "Spreadsheet",
      },
      {
        key: ROUTES.BRANCH,
        icon: <ApartmentOutlined />,
        label: "Branches",
      },
      {
        key: ROUTES.ADVISOR,
        icon: <SolutionOutlined />,
        label: "Advisors",
      },
      {
        key: ROUTES.TOPICS,
        icon: <TagOutlined />,
        label: "Topics",
      },
    ],
    [newMessageCount],
  );
  const managementItems = useMemo(
    () => [
      {
        key: "TEAM_GROUP",
        icon: <TeamOutlined />,
        label: "Team",
        children: [
          {
            key: ROUTES.USERS,
            icon: <UsergroupAddOutlined />,
            label: "Users",
          },
          {
            key: ROUTES.TEAM,
            icon: <DeploymentUnitOutlined />,
            label: "Teams",
          },

          {
            key: ROUTES.CALENDAR,
            icon: <CalendarOutlined />,
            label: "Calendar",
          },
        ],
      },
      {
        key: ROUTES.DOCUMENTATION,
        icon: <FileTextOutlined />,
        label: "Documentation",
      },
    ],
    [],
  );

  return (
    <StyledSideBar
      trigger={null}
      collapsible
      collapsed={collapsed}
      width={260}
      collapsedWidth={70}
      onMouseEnter={() => setCollapsed(false)}
      onMouseLeave={() => setCollapsed(true)}
    >
      <SidebarContent>
        <Logo
          // @ts-ignore
          collapsed={collapsed}
          className="flex align-center sidebar-header"
        >
          <Typography.Title
            level={3}
            style={{ margin: 0, display: "contents" }}
            className="sidebar-title"
          >
            {collapsed ? (
              <img src={LogoImage} />
            ) : (
              <>
                <img src={LogoImage} />
                Kelu Portal
              </>
            )}
          </Typography.Title>
        </Logo>

        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          onClick={(item) => navigate(item.key)}
          items={[
            {
              key: ROUTES.DASHBOARD,
              icon: <DashboardOutlined />,
              label: "Dashboard",
            },
          ]}
        />

        <TenantMenu />
        {!collapsed && <MenuSection>COMMUNICATION</MenuSection>}
        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          onClick={(item) => navigate(item.key)}
          items={communicationItems}
        />

        {!collapsed && <MenuSection>MANAGEMENT</MenuSection>}
        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          onClick={(item) => navigate(item.key)}
          items={managementItems}
        />

        <Divider />

        <MoreMenu />
      </SidebarContent>
    </StyledSideBar>
  );
};

export default Sidebar;
